module.exports = __webpack_public_path__ + "img/download_icon.b2e236ae.svg";